import { render, staticRenderFns } from "./aivideo.vue?vue&type=template&id=7b4d5924&"
import script from "./aivideo.vue?vue&type=script&lang=js&"
export * from "./aivideo.vue?vue&type=script&lang=js&"
import style0 from "./aivideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports